export default "__VITE_ASSET__ef8f07b4__"